import { Dialog, Button, Grid, FormControl, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Container, Content, ContentText, RadioGroupContainer } from "./styles";
import DialogActions from "../../DialogActions/DialogActions";
import DialogTitle from "../../DialogTitle/DialogTitle";
import LoadingOverlay from "../../LoadingOverlay/LoadingOverlay";

export const optionsToExport = ["Export as excel selected data", "Export as excel all data"];

interface Props {
  handleExportToExcel: (option: "exportAllData" | "exportCurrent") => Promise<void>;
  disabled: boolean;
}

const ExportToExcelDialog = ({ handleExportToExcel, disabled }: Props) => {
  const { t } = useTranslation();
  const tRP = "components.export_tna_overviews";

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(optionsToExport[0]);

  const handleExport = async () => {
    setLoading(true);
    try {
      await handleExportToExcel(selectedOption === optionsToExport[0] ? "exportCurrent" : "exportAllData");

      setLoading(false);

      setOpen(false);

      setSelectedOption(optionsToExport[0]);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpen(false);

    setSelectedOption(optionsToExport[0]);
  };

  return (
    <>
      <Button
        title={`${t("buttons.export")}`}
        variant="contained"
        onClick={() => setOpen(true)}
        sx={{ textWrap: "nowrap" }}
        disabled={disabled}
      >
        {`${t("buttons.export")}`}
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
      >
        <LoadingOverlay loading={loading}>
          <DialogTitle
            title={`${t(`${tRP}.export_as_excel`)}`}
            handleClose={handleClose}
          />
          <Content>
            <Container>
              <Grid sx={{ padding: "5px" }}>
                <ContentText>{`${t(`${tRP}.select_how_to_export`)}`}</ContentText>
              </Grid>

              <RadioGroupContainer>
                <FormControl>
                  <RadioGroup
                    aria-labelledby="radio-group"
                    defaultValue={optionsToExport[0]}
                    name="radio-buttons-group"
                    onChange={(event, value) => {
                      setSelectedOption(value);
                    }}
                  >
                    {optionsToExport.map((option) => {
                      return (
                        <FormControlLabel
                          key={option}
                          value={option}
                          control={<Radio />}
                          label={option}
                        />
                      );
                    })}
                  </RadioGroup>
                </FormControl>
              </RadioGroupContainer>
            </Container>
          </Content>

          <DialogActions
            handleCancel={handleClose}
            useGoback
          >
            <Button
              onClick={handleExport}
              variant="contained"
            >
              {`${t("buttons.confirm")}`}
            </Button>
          </DialogActions>
        </LoadingOverlay>
      </Dialog>
    </>
  );
};

export default ExportToExcelDialog;
